import React from "react";
import { Navigate } from "react-router-dom";
import gettingDetails from "../../Utility/DataFetching/gettingDetails";
import constant from "../../Utility/Constants/constant";

const PrivateRoute = ({ children }) => {
  let token = "";

  try {
    // 🧠 Get session data from your utility
    const value = gettingDetails(constant.ABD_SESSION);

    // ✅ Check if data exists
    if (value) {
      const object = JSON.parse(value);
      token = object?.accessToken || "";
    }

    // ❌ If token missing or invalid, redirect to signin
    if (!token) {
      return <Navigate to="/signin" replace />;
    }

    // ✅ Token exists → allow access
    return children;
  } catch (error) {
    // 🚨 If JSON parse fails or anything unexpected → redirect safely
    console.error("Session parsing error:", error);
    return <Navigate to="/signin" replace />;
  }
};

export default PrivateRoute;
